// this is an autogenerated file from App/Account/Content/Tasks/mutation-delete-stage-subscriber.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Tasks($stage_id: uuid!, $user_id: uuid!) {
  delete_tasks_subscribers(
    where: { stage_id: { _eq: $stage_id }, user_id: { _eq: $user_id } }
  ) {
    affected_rows
  }
}

`